import React from 'react';
import { useSelector } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import { AutocompleteValueField } from 'components/form';
import { portalConfigurationsSelectors } from 'redux/portalConfigurationReducer';

import { FinanceProgramForm } from '../../../../schema';
import { useDealerTiersOptions } from '../../../../hooks/useDealerTiersOptions';

interface Props {
  isLender: boolean;
}

export const DealerTiersField = ({ isLender }: Props) => {
  const isTieredDealersEnabled = useSelector<any, boolean>(portalConfigurationsSelectors.isTieredDealersEnabled);

  const { control, setValue } = useFormContext<FinanceProgramForm>();

  const { options: dealerTiersOptions, loading: dealerTiersLoading } = useDealerTiersOptions({
    skip: !isLender || !isTieredDealersEnabled,
  });

  if (!isLender || !isTieredDealersEnabled) return null;

  return (
    <AutocompleteValueField
      control={control}
      loading={dealerTiersLoading}
      options={dealerTiersOptions}
      name="program.first.details.dealerTier"
      extraAction={() => {
        setValue('program.first.details.dealers', []);
      }}
      textFieldProps={{
        label: 'Tier',
        size: 'small',
      }}
    />
  );
};
